module.exports = __webpack_public_path__ + "static/colgadas-006.thumb-fa2e7230c1b85bbe1cf08420e77d555f.jpg";